// extracted by mini-css-extract-plugin
export default {"button":"_2kd-4","buttonContainer":"_2KHHH","loaderContainer":"_2dbBh"};